export default __webpack_public_path__ + "static/Marriage-5181f022d25b5216f0178486c31eb24c.png";